import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { spacing } from "@layout";

export const useStyles = () => {
  const { theme } = useTheme();

  const styles: Record<string, CSSProperties> = {
    eyebrow: {
      textTransform: "uppercase",
      letterSpacing: 0.88,
      color: theme.text.secondary,
    },
    laterHint: {
      color: theme.text.secondary,
    },
    footer: {
      display: "flex",
      flexDirection: "column",
    },
    footerContent: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "center",
      marginTop: 0,
      marginBottom: spacing.m,
    },
    footerText: {
      marginLeft: spacing.xs,
    },
  };

  return styles;
};
